
import Vue from 'vue';
import RunnitCarousel from './RunnitCarousel.vue';
import { RUNNIT_NODE_DEF_TAG_TYPE, RunnitNodeDefTagType } from '@run-diffusion/shared';
import { mapState } from 'vuex';

export default Vue.extend({
	name: 'RunnitTagFilterCarousel',
	props: {
		tags: { type: Array, default: () => [] },
		selectedTagsMap: { type: Object, default: () => ({}) },
	},
	data () {
		return {
			RUNNIT_NODE_DEF_TAG_TYPE,
		};
	},
	computed: {
		...mapState([
			'user',
		]),
		filteredTags () {
			const excludedTypes: RunnitNodeDefTagType[] = [
				RUNNIT_NODE_DEF_TAG_TYPE.HOME_PAGE,
				RUNNIT_NODE_DEF_TAG_TYPE.INDUSTRY,
				RUNNIT_NODE_DEF_TAG_TYPE.TRAINING_TYPE,
				RUNNIT_NODE_DEF_TAG_TYPE.TRAINING_QUALITY,
				RUNNIT_NODE_DEF_TAG_TYPE.INTERNAL,
			];
			return this.tags.filter(tag => this.user.isAdmin || !excludedTypes.includes(tag.type));
		},
	},
	components: {
		RunnitCarousel,
	},
});
